import React, { useCallback, useState, useEffect } from "react";
import {
  DropZone,
  Page,
  FormLayout,
  TextField,
  Card,
  Checkbox,
  Stack,
  ButtonGroup,
  Button,
  InlineError,
} from "@shopify/polaris";
import axios from "../Assets/Lib/axios";
import { useParams } from "react-router-dom";
import Instruction from "./Instruction";
import { ColorsMajor } from "@shopify/polaris-icons";
import { accessEditSections } from "../Helpers";

const IframeSection = (props) => {
  let object = JSON.parse(props.object);
  console.log("object=", object);
  const { id } = useParams();
  const handleChangeScript = (newValue) => {
    setItem({ ...item, script: newValue });
  };

  const handleChangeCss = (newValue) => {
    setItem({ ...item, css: newValue });
  };

  const handleChange = (newChecked) => {
    setItem({ ...item, active: newChecked });
  };
  const [item, setItem] = useState({
    script: "",
    active: "",
  });
  useEffect(() => {
    object = JSON.parse(props.object);
    setItem({
      script: object?.details?.script ? object?.details?.script : "",
      active: object?.details?.is_active ? true : false,
      instruction: object?.instructions ? object?.instructions : "",
    });
  }, [props.object]);
  return (
    <FormLayout>
      {/* <Instruction
        text={item.instruction}
        pageId={id}
        sectionId={props.sectionId}
        handleRefreshSections={props.handleRefreshSections}
      /> */}

      <div style={{ float: "right" }}>
        <ButtonGroup>
          {/* <Button
            onClick={() => {
              setBoolRichTextTools(!boolRichTextTools);
            }}
            plain
          >
            <img src={boolRichTextTools ? showTools : hideTools} width={22} />
          </Button> */}

          {/* <Button
            plain
            onClick={() => props.handleCustomizeStyles()}
            icon={ColorsMajor}
          >
            Customize Styles
          </Button> */}
        </ButtonGroup>
      </div>
      <FormLayout.Group>
        <TextField
          value={item.script}
          onChange={handleChangeScript}
          label="Script"
          multiline={20}
        />
      </FormLayout.Group>
      <Checkbox
        label="Is Active"
        checked={item.active}
        onChange={handleChange}
      />
      <FormLayout.Group>
        <div style={{ float: "right" }}>
          <Button
            primary
            onClick={handleSave}
            loading={props.isSaving}
            disabled={!accessEditSections()}
          >
            Save
          </Button>
        </div>
      </FormLayout.Group>
    </FormLayout>
  );
  function handleSave() {
    props.handleSavingState();
    const form_data = new FormData();
    form_data.append("script", item.script);
    form_data.append("is_active", item.active ? 1 : 0);
    form_data.append("_method", "PATCH");
    props.selectedChannels && props.selectedChannels.length
      ? props.selectedChannels.forEach((selected, index) =>
          form_data.append(`channels[${index}]`, selected)
        )
      : form_data.append(`channels`, []);
    axios
      .post(`/pages/${id}/sections/${props.sectionId}`, form_data)
      .then((res) => {
        props.handleSaveAndRefresh();
      })
      .catch((err) => console.log(""));
  }
};
export default IframeSection;
